import TrackingServicesFactory from '../../tracking/Services/factory.js'
import UserRepositoriesFactory from '../../user/Repositories/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import MappersFactory from '../Mappers/factory.js'
import RepositoriesFactory from '../Repositories/factory.js'
import ValueObjectsFactory from '../ValueObjects/factory.js'
import GetAuthenticationTrackingService from './GetAuthenticationTrackingService.js'
import GetScreensetService from './GetScreensetService.js'
import LoginAuthenticationService from './LoginAuthenticationService.js'
import NotifyAuthenticationPasswordService from './NotifyAuthenticationPasswordService.js'
import VerifyAuthenticationService from './VerifyAuthenticationService.js'

export default class AuthenticationServicesFactory {
  static getAuthenticationTrackingService = ({config}) =>
    new GetAuthenticationTrackingService({
      gigyaEventToPageNameMapper: MappersFactory.gigyaEventToPageNameAuthenticationMapper({config}),
      trackingDataService: TrackingServicesFactory.getPageTrackingDataService({
        config
      })
    })

  static loginAuthenticationService = ({config}) =>
    new LoginAuthenticationService({
      authenticationRepository: RepositoriesFactory.httpAuthenticationRepository({config}),
      cookieRepository: RepositoriesFactory.cookieAuthenticationRepository({
        config
      }),
      legacyCookieRepository: RepositoriesFactory.legacyCookieAuthenticationRepository({config}),
      sessionStorageRepository: RepositoriesFactory.sessionStorageAuthenticationRepository({config}),
      userRepositoryFactory: UserRepositoriesFactory.cookieUserRepository({
        config
      })
    })

  static notifyAuthenticationPasswordService = ({config}) =>
    new NotifyAuthenticationPasswordService({
      repository: RepositoriesFactory.httpAuthenticationRepository({config})
    })

  static getScreensetService = ({config}) =>
    new GetScreensetService({
      repository: RepositoriesFactory.screensetRepository({config})
    })

  static verifyAuthenticationService = ({config}) => {
    return new VerifyAuthenticationService({
      config,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      verifyAuthenticationValueObjectFactory: ValueObjectsFactory.verifyAuthenticationValueObject,
      httpAuthenticationRepository: RepositoriesFactory.httpAuthenticationRepository({config}),
      cookieAuthenticationRepository: RepositoriesFactory.cookieAuthenticationRepository({
        config
      })
    })
  }
}
